import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Virtuoso } from 'react-virtuoso'
import { motion, AnimateSharedLayout, AnimatePresence } from "framer-motion";

import { Paper, Button, Animation, Tabs } from 'components'
import { ItemModal } from 'features'
import NotificationCard from './NotificationCard'

import * as actionCreators from 'store/actions'
import { getItem } from 'utils'
import { Item } from 'schema'
import { FaTimes, FaFile } from 'react-icons/fa';
import { isBefore } from 'date-fns'
import { timezoneDate, momentDate } from 'utils'

const Container = styled.div`
    background-color: var(--secondary-color);
    width: fit-content;
    width: 20rem;
    height: 40vh;
    font-size: var(--popout-font-size);
    padding: 0.5rem;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    :focus{
        outline: none;
    }
`

const Body = styled.div`
    height: 100%;
    flex-grow: 4;
    overflow-x: hidden;
`

const Wrapper = styled.div`
    width: 200%;
    height: 100%;
    display: grid;
    grid-template-columns: 50% 50%;
`

const Placeholder = styled.div`
    font-size: 0.9rem;
    color: var(--secondary-accent-color);
    margin: 1rem 0;
    text-align: center;
`

class Notifications extends Component {
    constructor(props) {
        super(props);
        this.tabOptions = [
            {content: 'Notifications', value:'notifications'},
            {content: 'Upcoming', value:'upcoming'},
        ]
        this.tabStyle = {
            main: {
                width: '100%',
                backgroundColor: 'var(--primary-color)'
            },
            tab: {
                width: null,
                padding: '0.4rem'
            }
        }

        this.state = {
            tab: 'notifications'
        }

    }

    itemModal = (alert) => {
        if(alert){
            if(alert['secID'] && alert['secID']['relation'] === 'item'){
                const item = this.props.data['items'][alert['secID']['id']]
                // Open the modal
                this.props.setModal(<ItemModal itemID={alert.secID['id']}/>, `${alert.secID['id']}_ItemModal`)
                this.props.closeHandler && this.props.closeHandler()
            }
        }
    }

    getBlocks = () => {
        // Sort and generate alerts
        let notifications = []
        let upcoming = []
        let alerts = this.props.data['alerts']
        alerts = Object.values(alerts).sort(function(a, b) {
            return new Date(a.date) - new Date(b.date);
        });
        alerts = alerts.reverse()
        alerts = alerts.map(alert => {
            const before = isBefore(new Date(alert.date), new Date())
            // Filter alerts that havent occurred
            if(alert['secID']['relation'] === 'item'){
                const itemIDs = Object.keys(this.props.data['items'])

                // Filter deleted items
                if(itemIDs.includes(alert['secID']['id'])){
                    const item = this.props.data['items'][alert['secID']['id']]
                    const includes = Object.values(item['alerts']).includes(alert['alertID'])

                    // Filter old alerts and completed items
                    if(includes){
                        before && notifications.push(alert)
                        !before && upcoming.push(alert)
                    } 
                } 
            }    
        })

        // Notifications
        let notificationBlocks = notifications.map(alert => {
            const item = this.props.data['items'][alert['secID']['id']]
            const incomplete = item['status'] === 'INCOMPLETE'
            const title = item.getPlainText()
            const subtitle = momentDate(item['start_time'] || item['end_time'] || item['start_date'] || item['end_date'], this.props.user['timezone'])
                            .format(!item['start_time'] & !item['end_time']? 'ddd, MMM D Y' : 'ddd, MMM D Y (h:mma)')
            return <NotificationCard title={title} subtitle={subtitle} date={alert['date']} icon={<FaFile/>} onSelect={() => {this.itemModal(alert)}}/>
        })
        notificationBlocks.length === 0 && notificationBlocks.push(<Placeholder>No notifications</Placeholder>)
        const notificationList = <Virtuoso style={{ height: '100%' }}
                                totalCount={notificationBlocks.length}
                                itemContent={index => (notificationBlocks[index])}/>

        // Upcoming
        let upcomingBlocks = upcoming.map(alert => {
            const item = this.props.data['items'][alert['secID']['id']]
            const title = item.getPlainText()
            const subtitle = momentDate(item['start_time'] || item['end_time'] || item['start_date'] || item['end_date'], this.props.user['timezone'])
                            .format(!item['start_time'] & !item['end_time']? 'ddd, MMM D Y' : 'ddd, MMM D Y (h:mma)')
            return <NotificationCard title={title} subtitle={subtitle} date={alert.date} icon={<FaFile/>} onSelect={() => {this.itemModal(alert)}}/>
        })
        upcomingBlocks.length === 0 && upcomingBlocks.push(<Placeholder>No upcoming items</Placeholder>)
        const upcomingList = <Virtuoso style={{ height: '100%' }}
                                totalCount={upcomingBlocks.length}
                                itemContent={index => (upcomingBlocks[index])}/>
        
        return {notifications: notificationList, upcoming: upcomingList}
    }

    render() {
        const blocks = this.getBlocks()      
        return (
            <Paper style={{margin: '0 0.5rem 0'}}>
                <Container>
                    <Tabs onSelect={(tab) => this.setState({tab: tab})} styles={this.tabStyle}
                        options={{notifications: 'Notifications', upcoming: 'Upcoming'}} 
                        selected={this.state.tab}/>

                    <Body>
                        <AnimatePresence initial={false}>
                            {this.state.tab === 'notifications' ?
                            <motion.div key='notifications' size='100%' position="relative" background='transparent'
                                initial="right"
                                animate="left"
                                exit="right"
                                variants={{
                                    left: { x: 0, height: '100%' },
                                    right: { x: '-100%', height: '100%' }
                                }}
                                transition={{ duration: 0.3 }}>
                                <Wrapper>
                                    {blocks['notifications']}
                                    {blocks['upcoming']}
                                </Wrapper>
                            </motion.div> :
                            <motion.div key='upcoming' size='100%' position="relative" background='transparent'
                                initial="left"
                                animate="right"
                                exit="left"
                                variants={{
                                    left: { x: 0, height: '100%' },
                                    right: { x: '-100%', height: '100%' }
                                }}
                                transition={{ duration: 0.3 }}>
                                <Wrapper>
                                    {blocks['notifications']}
                                    {blocks['upcoming']}
                                </Wrapper>
                            </motion.div> }
                        </AnimatePresence>
                        
                    </Body>
                </Container>
            </Paper>
        )
    }
    
}
const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        // data: state.db.data,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),

    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Notifications );
